import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { ProjectsPage } from './pages/ProjectsPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { OpportunitiesPage } from './pages/OpportunitiesPage';
import { WeatherAdvisoryPage } from './pages/WeatherAdvisoryPage';
import { ImportExportPage } from './pages/ImportExportPage';
import { SectorStatisticsPage } from './pages/SectorStatisticsPage';
import { GuidelinesServicesPage } from './pages/GuidelinesServicesPage';
import { AgenciesPage } from './pages/AgenciesPage';
import { MediaPage } from './pages/MediaPage';
import { VisionMissionPage } from './pages/VisionMissionPage';
import { MinistryStructurePage } from './pages/MinistryStructurePage';
import { DirectoratePage } from './pages/DirectoratePage';
import { LeadershipPage } from './pages/LeadershipPage';
import { ContactPage } from './pages/ContactPage';
import { ProductionDataPage } from './pages/ProductionDataPage';
import { MarketPricesPage } from './pages/MarketPricesPage';
import { TradeDataPage } from './pages/TradeDataPage';
import { LicensingPage } from './pages/LicensingPage';
import { ApplicationsPage } from './pages/ApplicationsPage';
import { ProgramsPage } from './pages/ProgramsPage';
import { CoctuPage } from './pages/CoctuPage';
import { CdougaPage } from './pages/CdougaPage';
import { DdaPage } from './pages/DdaPage';
import { NaadsPage } from './pages/NaadsPage';
import { NaroPage } from './pages/NaroPage';
import { NagrcdbPage } from './pages/NagrcdbPage';
import { UcdaPage } from './pages/UcdaPage';
export function App() {
  return <div className="min-h-screen w-full flex flex-col bg-white" data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/projects" element={<ProjectsPage data-id="element-5" />} data-id="element-4" />
        <Route path="/programs" element={<ProgramsPage data-id="element-7" />} data-id="element-6" />
        <Route path="/coctu" element={<CoctuPage data-id="element-9" />} data-id="element-8" />
        <Route path="/cdouga" element={<CdougaPage data-id="element-11" />} data-id="element-10" />
        <Route path="/dda" element={<DdaPage data-id="element-13" />} data-id="element-12" />
        <Route path="/naads" element={<NaadsPage data-id="element-15" />} data-id="element-14" />
        <Route path="/naro" element={<NaroPage data-id="element-17" />} data-id="element-16" />
        <Route path="/nagrcdb" element={<NagrcdbPage data-id="element-19" />} data-id="element-18" />
        <Route path="/ucda" element={<UcdaPage data-id="element-21" />} data-id="element-20" />
        <Route path="/resources" element={<ResourcesPage data-id="element-23" />} data-id="element-22" />
        <Route path="/opportunities" element={<OpportunitiesPage data-id="element-25" />} data-id="element-24" />
        <Route path="/weather-advisory" element={<WeatherAdvisoryPage data-id="element-27" />} data-id="element-26" />
        <Route path="/import-export" element={<ImportExportPage data-id="element-29" />} data-id="element-28" />
        <Route path="/sector-statistics" element={<SectorStatisticsPage data-id="element-31" />} data-id="element-30" />
        <Route path="/guidelines-services" element={<GuidelinesServicesPage data-id="element-33" />} data-id="element-32" />
        <Route path="/agencies" element={<AgenciesPage data-id="element-35" />} data-id="element-34" />
        <Route path="/media" element={<MediaPage data-id="element-37" />} data-id="element-36" />
        <Route path="/about/vision-mission" element={<VisionMissionPage data-id="element-39" />} data-id="element-38" />
        <Route path="/about/structure" element={<MinistryStructurePage data-id="element-41" />} data-id="element-40" />
        <Route path="/about/:slug" element={<DirectoratePage data-id="element-43" />} data-id="element-42" />
        <Route path="/about/leadership" element={<LeadershipPage data-id="element-45" />} data-id="element-44" />
        <Route path="/contact" element={<ContactPage data-id="element-47" />} data-id="element-46" />
        <Route path="/production-data" element={<ProductionDataPage data-id="element-49" />} data-id="element-48" />
        <Route path="/market-prices" element={<MarketPricesPage data-id="element-51" />} data-id="element-50" />
        <Route path="/trade-data" element={<TradeDataPage data-id="element-53" />} data-id="element-52" />
        <Route path="/licensing" element={<LicensingPage data-id="element-55" />} data-id="element-54" />
        <Route path="/applications" element={<ApplicationsPage data-id="element-57" />} data-id="element-56" />
      </Routes>
    </div>;
}